





















import LoaderState from '@front-app/components/LoaderState.vue';
import { Size } from '@front-app/components/constants';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: { LoaderState },
	props: {
		lastUpdateDate: {
			type: Date,
			required: false,
			default: null,
		},
		isUpdating: Boolean,
		textKey: {
			type: String,
			default: 'last-updated.last-updated',
		},
	},
	setup() {
		return {
			loaderSize: Size.SMALL,
		};
	},
});
